export const RETENTION_STATUSES = {
  CANCELED: {
    label: 'Canceled',
    background: '#FDE7E9',
    color: '#8C1D18',
  },
  NEW: { label: 'New', background: '#E0EAFF', color: '#001C57' },
  DUE: { label: 'Due', background: '#FFF1D6', color: '#5C3B00' },
  LAPSED: { label: 'Lapsed', background: '#FFE4D6', color: '#7A2E00' },
  ACTIVE: { label: 'Active', background: '#E3F4EA', color: '#0B5A2A' },
  INACTIVE: { label: 'Inactive', background: '#EBF0F2', color: '#40484C' },
}

// Most urgent first: the backend's by_urgency attention order, then Active
// before Inactive (the backend ties those two).
export const URGENCY_ORDER = Object.keys(RETENTION_STATUSES)

export const STATUS_FILTER_OPTIONS = [
  { value: 'all', label: 'All Students' },
  { value: 'attention', label: 'Needs Follow-Up' },
  ...URGENCY_ORDER.map(status => ({
    value: status,
    label: RETENTION_STATUSES[status].label,
  })),
]

export const SNOOZE_DAYS = 14
